export class GlobalConstants {
    static readonly CURRENT_USER_KEY = 'current-user';
    static readonly PKCE_VERIFIER_KEY = 'oauth.pkce.verifier';
    static readonly OAUTH_STATE_KEY = 'oauth.state';
    static readonly POST_LOGIN_URL_KEY = 'oauth.postLoginUrl';
    static readonly OAUTH_BEARER_KEY = 'oauth.bearer';
    static readonly THEME_KEY = 'theme';
    static readonly LANG_KEY = 'lang';
}

